/*  iceberg-ui  */
import {
    Box,
    IconName,
    IconVariantType,
    IconWithVariant
} from '@auviknetworks/iceberg-ui';

/* Shared */
import { DarkTooltip } from 'application/Shared/Components/Tooltips';
import { FontSizes } from 'application/Shared/Constants';

/* React */
import React from 'react';

export interface IconCellType {
    size?: number;
    src: IconName;
    variant?: IconVariantType;
    tooltipText?: string;
}

export const IconCell = ({
    condition,
    iconCellProps
}: {
    condition: boolean;
    iconCellProps: IconCellType;
}): JSX.Element | null =>
    condition ? (
        <DarkTooltip arrow title={iconCellProps.tooltipText}>
            <Box sx={{ lineHeight: 0, width: 'fit-content' }}>
                <IconWithVariant
                    data-testid={`iconCell_${iconCellProps.src}`}
                    variant={iconCellProps.variant || 'danger'}
                    src={iconCellProps.src}
                    size={iconCellProps.size || FontSizes[2]}
                />
            </Box>
        </DarkTooltip>
    ) : null;
